function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * Net-flow accounting for the Token Supply table.
 *
 * Each block column shows how value moved into the five major header buckets
 * during block production, derived from protocol transitions (not snapshot diffs).
 *
 * Conservation: current + previous + utxo + treasury + graveyard === 0
 */

var NET_FLOW_SECTION_TITLE = 'Net Flow';
var NET_FLOW_ROWS = [{
  key: 'current_unpaid',
  label: '→ Current Block Unpaid'
}, {
  key: 'previous_unpaid',
  label: '→ Previous Block Unpaid'
}, {
  key: 'utxo',
  label: '→ UTXO'
}, {
  key: 'treasury',
  label: '→ Treasury'
}, {
  key: 'graveyard',
  label: '→ Graveyard'
}];
var NET_FLOW_TOTAL_FIELD = {
  key: 'total',
  label: 'TOTAL NET FLOW'
};
var NET_FLOW_SECTION_ROWS = [].concat(NET_FLOW_ROWS, [NET_FLOW_TOTAL_FIELD]);
var EMPTY_BLOCK_HASH = '0000000000000000000000000000000000000000000000000000000000000000';
function toBigInt(value) {
  if (value === undefined || value === null || value === '') {
    return 0n;
  }
  try {
    return BigInt(value);
  } catch (err) {
    return 0n;
  }
}
function hasGoldenTicket(row) {
  if (!row) {
    return false;
  }
  var value = row.has_golden_ticket;
  return value === true || value === 1 || value === '1';
}
function hasGrandparent(parentRow) {
  var hash = String((parentRow === null || parentRow === void 0 ? void 0 : parentRow.previous_block_hash) || '').trim();
  return Boolean(hash && hash !== EMPTY_BLOCK_HASH);
}

/**
 * Resolve the previous longest-chain block row via previous_block_hash.
 * Checks the displayed window first, then the Explorer blocks database.
 */
function resolvePreviousBlockRow(_x, _x2, _x3, _x4) {
  return _resolvePreviousBlockRow.apply(this, arguments);
}
/**
 * Derive per-category net flows for one block from protocol accounting fields.
 */
function _resolvePreviousBlockRow() {
  _resolvePreviousBlockRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(currentRow, hashIndex, mod, toStatsRow) {
    var _mod$database;
    var parentHash, dbRow, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          parentHash = String((currentRow === null || currentRow === void 0 ? void 0 : currentRow.previous_block_hash) || '').trim();
          if (!(!parentHash || parentHash === EMPTY_BLOCK_HASH)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          if (!(hashIndex !== null && hashIndex !== void 0 && hashIndex.has(parentHash))) {
            _context.n = 2;
            break;
          }
          return _context.a(2, hashIndex.get(parentHash));
        case 2:
          if (!(!(mod !== null && mod !== void 0 && (_mod$database = mod.database) !== null && _mod$database !== void 0 && _mod$database.getStatisticsByBlockHash) || typeof toStatsRow !== 'function')) {
            _context.n = 3;
            break;
          }
          return _context.a(2, null);
        case 3:
          _context.p = 3;
          _context.n = 4;
          return mod.database.getStatisticsByBlockHash(parentHash);
        case 4:
          dbRow = _context.v;
          return _context.a(2, dbRow ? toStatsRow(dbRow) : null);
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error('Explorer: failed to resolve previous block for supply net flow', _t);
          return _context.a(2, null);
      }
    }, _callee, null, [[3, 5]]);
  }));
  return _resolvePreviousBlockRow.apply(this, arguments);
}
function computeNetFlowsForBlock(current, parent) {
  if (!current) {
    return null;
  }
  var parentTotalFees = parent ? toBigInt(parent.total_fees) : 0n;
  var hasGt = hasGoldenTicket(current);
  var parentHadGt = hasGoldenTicket(parent);

  // New fees enter the current block pool; parent fee pool clears into payouts or carry.
  var currentUnpaid = toBigInt(current.total_fees) - parentTotalFees;
  var previousUnpaid = 0n;
  if (parent && !hasGt) {
    previousUnpaid += parentTotalFees;
    if (!parentHadGt && hasGrandparent(parent)) {
      previousUnpaid -= toBigInt(parent.previous_block_unpaid);
    }
  }
  var treasury = toBigInt(current.total_payout_treasury) - toBigInt(current.total_payout_atr);
  var graveyard = toBigInt(current.total_payout_graveyard);
  var utxo = toBigInt(current.total_payout_routing) + toBigInt(current.total_payout_mining) + toBigInt(current.total_payout_atr) - toBigInt(current.total_fees);
  var total = parent ? currentUnpaid + previousUnpaid + utxo + treasury + graveyard : null;
  return {
    current_unpaid: currentUnpaid,
    previous_unpaid: previousUnpaid,
    utxo: utxo,
    treasury: treasury,
    graveyard: graveyard,
    total: total
  };
}

/**
 * Compute net flows for every displayed block (low block id → high).
 */
function computeNetFlows() {
  return _computeNetFlows.apply(this, arguments);
}
function _computeNetFlows() {
  _computeNetFlows = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var statsRows,
      options,
      mod,
      toStatsRow,
      hashIndex,
      results,
      i,
      row,
      parent,
      flows,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          statsRows = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          mod = options.mod, toStatsRow = options.toStatsRow;
          hashIndex = new Map(statsRows.filter(function (row) {
            return row === null || row === void 0 ? void 0 : row.block_hash;
          }).map(function (row) {
            return [row.block_hash, row];
          }));
          results = [];
          i = 0;
        case 1:
          if (!(i < statsRows.length)) {
            _context2.n = 4;
            break;
          }
          row = statsRows[i];
          _context2.n = 2;
          return resolvePreviousBlockRow(row, hashIndex, mod, toStatsRow);
        case 2:
          parent = _context2.v;
          flows = computeNetFlowsForBlock(row, parent);
          results.push({
            block_id: row === null || row === void 0 ? void 0 : row.block_id,
            block_hash: row === null || row === void 0 ? void 0 : row.block_hash,
            flows: flows
          });
        case 3:
          i++;
          _context2.n = 1;
          break;
        case 4:
          return _context2.a(2, results);
      }
    }, _callee2);
  }));
  return _computeNetFlows.apply(this, arguments);
}
function formatNetFlowTone(nolanValue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$isTotal = options.isTotal,
    isTotal = _options$isTotal === void 0 ? false : _options$isTotal;
  if (nolanValue === null || nolanValue === undefined) {
    return 'muted';
  }
  if (isTotal && nolanValue !== 0n) {
    return 'error';
  }
  if (nolanValue === 0n) {
    return 'zero';
  }
  if (nolanValue > 0n) {
    return 'positive';
  }
  return 'negative';
}
module.exports = {
  NET_FLOW_SECTION_TITLE: NET_FLOW_SECTION_TITLE,
  NET_FLOW_ROWS: NET_FLOW_ROWS,
  NET_FLOW_TOTAL_FIELD: NET_FLOW_TOTAL_FIELD,
  NET_FLOW_SECTION_ROWS: NET_FLOW_SECTION_ROWS,
  toBigInt: toBigInt,
  hasGoldenTicket: hasGoldenTicket,
  hasGrandparent: hasGrandparent,
  resolvePreviousBlockRow: resolvePreviousBlockRow,
  computeNetFlowsForBlock: computeNetFlowsForBlock,
  computeNetFlows: computeNetFlows,
  formatNetFlowTone: formatNetFlowTone
};